import { parse, stringify } from 'query-string';
import { isURL } from 'validator';

export const keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40,
};

export const createMarkup = (markup) => ({ __html: markup });

export const getRelativeOfficeURL = (path, query) => {
  let domain = window.location.hostname.replace('cabinet.', '');
  let reqParams = '';

  if (domain === 'localhost') domain = 'offerrum.com';

  if (query) {
    const params = query[0];
    const options = query[1];
    reqParams = `?${stringify(params, options)}`;
  }
  return `//my.${domain}${path ? `/${path}` : ''}${reqParams}`;
};

export const getRelativeStoreURL = () => {
  let domain = window.location.hostname.replace('cabinet.', '');

  if (domain === 'localhost') domain = 'offerrum.com';

  return `//store.${domain}`;
};

/**
 * Redirect after login
 *
 * @param {string} url URL to redirect
 * @param {number} timeout Delay
 */
export const redirectToOffice = (url = getRelativeOfficeURL(), timeout = 0) => {
  localStorage.removeItem('redirect_url');
  Cookies.remove('redirect_url', { domain: '.tutorplace.ru', path: '/' });

  setTimeout(() => {
    window.location.href = url;
  }, timeout);
};

export const Cookies = {
  get(name) {
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  set(name, value, options = {}) {
    let expires = options.expires;

    if (typeof expires === 'number' && expires) {
      const d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
    }

    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = `${name}=${value}`;

    for (let propName in options) {
      updatedCookie += `; ${propName}`;
      let propValue = options[propName];

      if (propValue !== true) {
        updatedCookie += '=' + propValue;
      }
    }

    document.cookie = updatedCookie;
  },

  remove(name, options = {}) {
    this.set(name, '', { ...options, expires: -1 });
  },
};

export const isNil = (children) =>
  children === null || children === undefined || (Array.isArray(children) && children.length === 0);

export const isString = (children) => typeof children === 'string';

export const getUnique = (array = []) => array.filter((v, i, a) => a.indexOf(v) === i);

export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  let results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getBaseURL = (isProduction) => {
  let domain = window.location.hostname.replace('cabinet.', '');

  if (domain.includes('.devstage.ttplace.online')) {
    return 'https://api.devstage.ttplace.online';
  }

  if (domain.includes('.local')) {
    return 'http://api.incus.local';
  }

  if (domain === 'localhost') domain = 'offerrum.test';

  let url = `https://api.s1.stage.offerrum.com`;

  if (isProduction) {
    url = `//api.${domain}`;
  } else {
    const local = Cookies.get('X-LOCAL-ID');
    url = local ? `//api.s${local}.${domain}` : url;
  }

  return url;
};

/**
 * Send Google Analytics event
 *
 * @param {object} data Event data
 * @param {function} cb Callback
 * @return {boolean}
 */
export const triggerGAEvent = (
  { action, category, label, value, dataLayerName = 'dataLayer' },
  cb = () => {},
) => {
  window[dataLayerName] &&
    window[dataLayerName].push({
      event: 'event-to-ga',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    });

  cb();

  return true;
};

export const checkForRef = () => {
  const params = parse(window.location.search);
  const { ref } = params;

  if (ref) {
    const expire = new Date(2019, 0, 1);
    Cookies.set('ref', ref, { domain: '.offerrum.com', path: '/', expires: expire });
  }
};

export const checkForRedirectUrl = () => {
  const params = parse(window.location.search);
  const { redirect_url = '', params: queryParams = '' } = params;
  const formattedParams = queryParams
    ? '?' +
      queryParams
        .split(',')
        .map((param) => param + '=1')
        .join('&')
    : '';

  if (isURL(redirect_url, { protocols: ['http', 'https'], require_protocol: true })) {
    localStorage.setItem('redirect_url', redirect_url + formattedParams);
  }
};

export const getUserChangedLocale = () => {
  return Cookies.get('offerrum_lang');
};

export const shouldDisableRecaptcha = () => {
  return true;
  // const { hostname, host, origin } = window.location;

  // return (
  //   // devstage
  //   origin.includes('.devstage.ttplace.online') ||
  //   host.includes('.devstage.ttplace.online') ||
  //   hostname.includes('.devstage.ttplace.online') ||
  //   // localhost
  //   origin.includes('.local') ||
  //   host.includes('.local') ||
  //   hostname.includes('.local') ||
  //   hostname === 'localhost'
  // );
};

export const isCabinet = () => window.location.hostname.indexOf('cabinet') === 0;

/**
 * Get element offset
 *
 * @param {HTMLElement} el Element
 * @param {number} offset Additional offset
 * @return {number} Element offset
 */
const getElementY = (el, offset = 0) => {
  if (el && el.getBoundingClientRect) {
    return window.pageYOffset + (el.getBoundingClientRect().top - offset);
  }

  return 0;
};

/**
 * Animated scroll to node
 * @param {HTMLElement} el Element to scroll
 * @param {number} duration Scroll duration in ms
 * @param {number} [offset] Offset from top
 */
export const animatedScrollTo = (el, duration, offset = 0) => {
  const startingY = window.pageYOffset;
  const elementY = getElementY(el, offset);

  // If element is close to page's bottom then window will scroll only to some position above the element.
  const targetY =
    document.body.scrollHeight - elementY < window.innerHeight
      ? document.body.scrollHeight - window.innerHeight
      : elementY;

  const diff = targetY - startingY;

  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  const easing = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);

  let start;

  if (!diff) return;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;

    // Elapsed miliseconds since start of scrolling.
    const time = timestamp - start;

    // Get percent of completion in range [0, 1].
    let percent = Math.min(time / duration, 1);

    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

export const detectAutofill = (element, delay = 600) => {
  if (!element) {
    return Promise.resolve(false);
  }
  return new Promise((resolve) => {
    setTimeout(() => {
      const isAutofilled =
        window.getComputedStyle(element, null).getPropertyValue('appearance') === 'menulist-button';
      resolve(isAutofilled);
    }, delay);
  });
};

export const getOfficeUrl = () => {
  if (
    window.location.origin.includes('.devstage.ttplace.online') ||
    window.location.host.includes('.devstage.ttplace.online')
  ) {
    return 'https://office.devstage.ttplace.online/dashboard';
  }

  if (window.location.origin.includes('.local') || window.location.host.includes('.local')) {
    return 'http://office.incus.local/dashboard';
  }

  if (window.location.host.includes('s1')) {
    return 'https://my.s1.stage.affiliate.tutorplace.ru';
  } else {
    return 'https://my.affiliate.tutorplace.ru';
  }
};
